<div class="page-loading-shade" *ngIf="isProcessing">
  <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
</div>

<div class="menu-container field-style">
  <div class="row menu-row-container">
    <div class="col-sm-6 gridName-container">
      <span class="gridName">Investigation Persons</span>
    </div>
  </div>
</div>

<div class="static-grid-container" *ngIf="!isSearchedPopupOpened">
  <div id="header-container" class="d-flex justify-content-end gap-3 mt-1 mb-3">
    <div class="">
      <div class="search-container">
        <span class="fa fa-search form-control-feedback"></span>
        <input type="text" class="form-control search_input" style="font-size: 13px;" placeholder="Search"
          [(ngModel)]="searchValue">
      </div>
    </div>
    <div class="">
      <div class="action-buttons-container d-flex gap-2">
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center" *ngIf="isFrozen"
          (click)="openAddPopup()" (keydown.enter)="openAddPopup()" matTooltip="Add Investigation Persons">
          <img src="../../../assets/img/cr_module/add_new.svg" width="18px" height="18px" alt="add new" />
          <span class="reload_text text-white">Add New</span>
        </div>
        <div class="addIconContiner d-flex gap-2 justify-content-center align-items-center"
          *ngIf="isFrozen && tempArray.length > 1" (click)="multiDelete()" (keydown.enter)="multiDelete()"
          matTooltip="Delete Multiple Investigation Persons">
          <i class="fa fa-trash"></i>
          <span class="reload_text text-white">Multi Delete</span>
        </div>
        <div class="reloadIconContiner d-flex gap-2 justify-content-center align-items-center" (click)="refreshGrid()"
          (keydown.enter)="refreshGrid()" matTooltip="Refresh Grid">
          <img src="../../../assets/img/cr_module/reload.svg" width="18px" height="18px" alt="reload" />
          <span class="reload_text">Reload</span>
        </div>
      </div>
    </div>
  </div>
  <table style="max-height: 45vh;" *ngIf="filteredParticipantsGrid.length">
    <thead>
      <th style="min-width: 60px; text-align: center;">
        <div style="display: flex;">
          <div>
            <i id="parent-menu-icons" class="fa-solid fa-ellipsis-vertical"></i>
          </div>
          <div style="margin-left: 5px;">
            <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="searchUserParentCheckBox"
              (change)="onParentCheckBoxChanged($event)">
          </div>
        </div>
      </th>

      <th class="grid-header-container"
        [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
          <span>User</span>
        </div>
      </th>

      <th class="grid-header-container"
        [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
          <span>Comments</span>
        </div>
      </th>

      <th class="grid-header-container"
        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
          <span>Created On</span>
        </div>
      </th>

      <th class="grid-header-container"
        [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
        <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
          <span>Created By</span>
        </div>
      </th>

      <th id="menu" class="sticky-col first-col"></th>
    </thead>
    <tbody>
      <tr class="data-row-container" *ngFor="let user of filteredParticipantsGrid; let idx = index;">
        <td style="min-width: 80px; text-align: center;">
          <div style="display: flex;">
            <div [ngClass]="user.userChildCheckBox ?'static_icon':'hover-menu-icons'">
              <i class="fa-solid fa-ellipsis-vertical"></i>
            </div>
            <div style="margin-left: 5px;">
              <input type="checkbox" style="zoom: 1.2;" [checked]="user.userChildCheckBox"
                (change)="onChildCheckBoxChanged($event, user, idx)">
            </div>
          </div>
        </td>
        <td class="row-data">{{ user.userName }}</td>
        <td class="row-data">{{ user.comments }}</td>
        <td class="row-data text-uppercase">
          {{ user.createdOn | date : (appService.getOneQmsDateFormat + ' HH:mm:ss') }}
        </td>
        <td class="row-data">{{ user.createdByUser }}</td>

        <td class="sticky-col first-col">
          <div class="action-icons" *ngIf="isFrozen">
            <i class="fa-sharp fa-solid fa-trash" matTooltip="Delete Investigation Persons" style="margin-left: 5px;"
              (click)="openDeletePopup(user)" (keydown.enter)="openDeletePopup(user)"></i>
          </div>
        </td>
      </tr>
    </tbody>
  </table>
</div>

<ng-template #addAndEditPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelAddAndEditFunction()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> {{ popupTitle }}</label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div id="filed-container">
      <div class="row">
        <div class="col-md-2">
          <label for="email">User</label>
        </div>
        <div class="col-md-10" id="search-container">
          <span class="fa fa-search form-control-feedback" (click)="searchUserFunction()"
            (keydown.enter)="searchUserFunction()"></span>
          <input id="managerId" class="form-control" type="text" [(ngModel)]="participants.userName"
            placeholder="Search" disabled>
        </div>
      </div>
      <div class="row">
        <div class="col-md-2">
          <label id="shortDescription-validation" for="email ">Comments</label>
        </div>
        <div class="col-md-10">
          <div class="row" style="margin-top: 2%;">
            <textarea id="shortDescription" class="input-filed-textarea uppercase" rows="4" cols="50"
              [(ngModel)]="participants.comments"></textarea>
          </div>
        </div>
      </div>
    </div>
  </div>
  <div class="button-continer btn-align" mat-dialog-actions>
    <button mat-stroked-button class="addButton" (click)="create(participants)" *ngIf="visibleAddButton">
      <i class="fas fa-plus"></i> Add
    </button>
    <button mat-stroked-button class="addButton" (click)="update(participants)" *ngIf="visibleEditButton">
      <i class="fas fa-user-edit"></i> Update
    </button>
    <button mat-stroked-button class="cancelButton" (click)="cancelAddAndEditFunction()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>

<ng-template #deletePopup>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelDeleteFunction()" mat-button><i
      class="fa popupClose">&#xf00d;</i></button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> {{ popupTitle }}</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div style="margin: 15px 15px;">
    <div>
      <div class="row">
        <div class="col-md-12">
          <div><label id="delete-reason-validation" for="email">Reason for Delete</label><span
              class="mandatory-symbol">*</span></div>
          <textarea type="text" class="input-filed-textarea uppercase" rows="4" cols="50"
            [(ngModel)]="participants.deleteReason"></textarea>
        </div>
      </div>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions>
      <button mat-stroked-button class="deleteButton" (click)="deleteFunction(participants)">
        <i class="fa fa-trash"></i> Delete
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelDeleteFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #searchManager>
  <div class="page-loading-shade" *ngIf="isProcessing">
    <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
  </div>
  <button class="close close-button" (click)="cancelSearchUserFunction()" mat-button>
    <i class="fa popupClose">&#xf00d;</i>
  </button>
  <div mat-dialog-title>
    <label for="title" class="popupTitle"> Search User(s)</label>
    <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
  </div>
  <div class="search-popup">
    <div class="row">
      <div class="col-md-4">
        <div><label for="email">User Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByUserName">
      </div>
      <div class="col-md-4">
        <div><label for="email">First Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByFirstName">
      </div>
      <div class="col-md-4">
        <div><label for="email">Last Name</label></div>
        <input class="search-filed-continers" type="text" [(ngModel)]="searchByLastName">
      </div>
      <div class="col-md-4">
        <div><label for="email">Email</label></div>
        <input class="search-filed-continers" type="email" [(ngModel)]="searchByEmailAddress">
        <div id="email-val-icon" class="field-icon-container"></div>
      </div>
      <div class="col-md-4">
        <div><label for="email">Designation</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDesignationCode"
          (closed)="designationSearchText=''" (click)="focusSearch('focus-designation-search')"
          (keydown.enter)="focusSearch('focus-designation-search')">
          <input type="search" id="focus-designation-search" class="dropdownsearchstyle"
            [(ngModel)]="designationSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
          <mat-option *ngFor="let item of designationCodeDropdown | assessmentSearch : designationSearchText"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
      <div class="col-md-4">
        <div><label for="email">Department</label></div>
        <mat-select matInput placeholder="Select" [(ngModel)]="searchByDepartmentCode"
          (closed)="departmentSearchText=''" (click)="focusSearch('focus-department-search')"
          (keydown.enter)="focusSearch('focus-department-search')">
          <input type="search" id="focus-department-search" class="dropdownsearchstyle"
            [(ngModel)]="departmentSearchText" matInput placeholder="search">
          <mat-option [value]="null" class="unselectStyle">Un-select</mat-option>
          <mat-option *ngFor="let item of departmentCodeDropdown | assessmentSearch : departmentSearchText"
            [value]="item.valueExp">
            {{ item.displayExp }}
          </mat-option>
        </mat-select>
      </div>
    </div>
    <div class="row">
      <div class="button-continer btn-align" mat-dialog-actions>
        <button mat-stroked-button class="addButton" (click)="searchUsersGridDataFunction()">
          <i class="fa-solid fa-magnifying-glass"></i> Search
        </button>
        <button mat-stroked-button class="cancelButton" *ngIf="!qualityUsers.length"
          (click)="cancelSearchUserFunction()">
          <i class="fa fa-close"></i> Cancel
        </button>
        <button mat-stroked-button class="cancelButton"
          *ngIf="searchByUserName || searchByFirstName || searchByLastName || searchByEmailAddress || searchByDesignationCode || searchByDepartmentCode || qualityUsers.length"
          (click)="resetSearchUsersGridDataFunction()">
          <i class="fas fa-undo"></i> Reset
        </button>
      </div>
    </div>
    <div class="table-container" *ngIf="qualityUsers.length">
      <table style="max-height: 45vh;">
        <thead>
          <th style="min-width: 60px; text-align: center;">
            <div style="display: flex;">
              <div>
                <i class="parent-menu-icons fa-solid fa-ellipsis-vertical"></i>
              </div>
              <div style="margin-left: 5px;" *ngIf="visibleAddButton">
                <input type="checkbox" style="zoom: 1.2;" [(ngModel)]="searchUserParentCheckBox"
                  (change)="onParentCheckBoxChanged($event)">
              </div>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>User Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>First Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Last Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '250px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Email</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Designation</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Department</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '140px','max-width': '200px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Manager Name</span>
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let user of qualityUsers; let idx = index;">
            <td style="min-width: 80px; text-align: center;">
              <div style="display: flex;">
                <div [ngClass]="user.userChildCheckBox ?'static_icon':'hover-menu-icons'">
                  <i class="fa-solid fa-ellipsis-vertical"></i>
                </div>
                <div style="margin-left: 5px;">
                  <input type="checkbox" style="zoom: 1.2;" [checked]="user.userChildCheckBox"
                    (change)="onChildCheckBoxChanged($event, user, idx)">
                </div>
              </div>
            </td>
            <td class="row-data">{{ user.userName }}</td>
            <td class="row-data">{{ user.firstName }}</td>
            <td class="row-data">{{ user.lastName }}</td>
            <td class="row-data">{{ user.emailAddress }}</td>
            <td class="row-data">{{ user.designation }}</td>
            <td class="row-data">{{ user.department }}</td>
            <td class="row-data">{{ user.managerName }}</td>
          </tr>
        </tbody>
      </table>
    </div>
    <div class="button-continer btn-align" mat-dialog-actions *ngIf="qualityUsers.length">
      <button mat-stroked-button class="addButton" (click)="addUserNameFunction()" [disabled]="!tempArray.length">
        <i class="fas fa-check"></i> Pick
      </button>
      <button mat-stroked-button class="cancelButton" (click)="cancelSearchUserFunction()">
        <i class="fa fa-close"></i> Cancel
      </button>
    </div>
  </div>
</ng-template>

<ng-template #resultPopup>
  <div class="ng-template-container">
    <div class="page-loading-shade" *ngIf="isProcessing">
      <app-custom-spinner *ngIf="isProcessing"></app-custom-spinner>
    </div>
    <button class="close close-button" (click)="cancelCopyResultPopup()" mat-button><i
        class="fa popupClose">&#xf00d;</i></button>
    <div mat-dialog-title>
      <label for="title" class="popupTitle"> Investigation Person Result(s) </label>
      <label for="app-name" class="popupAppTitle">One<span style="color:gold;">QMS</span> </label>
    </div>
    <div class="table-container" style="margin: 10px;">
      <table style="max-height: 65vh;">
        <thead>
          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '300px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Participant Name</span>
            </div>
          </th>

          <th class="grid-header-container"
            [ngStyle]="{'min-width': '100px','max-width': '350px','overflow': 'hidden','text-overflow': 'ellipsis','white-space': 'nowrap'}">
            <div class="thheader d-flex justify-content-between align-items-center gap-3 px-2 py-1">
              <span>Result</span>
            </div>
          </th>

          <th class="sticky-col first-col"></th>
        </thead>
        <tbody>
          <tr class="data-row-container" *ngFor="let r of responses; let idx = index;">
            <td class="row-data">{{ r.participant.userName }}</td>
            <td class="row-data" [ngStyle]=" r.response.resultType == 'S' ? {'color': 'green'} :{'color':'red'}">
              {{ r.response.result }}
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="d-flex justify-content-end gap-3 mx-3 button-continer" mat-dialog-actions>
    <button mat-stroked-button class="cancelButton" (click)="cancelCopyResultPopup()">
      <i class="fa fa-close"></i> Cancel
    </button>
  </div>
</ng-template>